<template>
	<div class="phase" :class="{ active: active_phase == phase }">
		
		<div v-if="phase.type == 'fight'" class="fight">
			<div class="intro">Un mot démoniaque apparait !</div>
			<div v-show="phase.enemy" class="enemy">
				<div class="word">
					<div v-for="letter in phase.enemy.letters" :key="letter.id" class="letter">
						<transition name="enemy">
							<div v-show="letter.active" class="letter-text">
								{{ letter.letter }}
							</div>
						</transition>
					</div>
				</div>
			</div>
			<transition name="life-losed">
				<div v-show="phase.life_losed > 0" class="lose-life">
					<div class="life">
						<span class="value">-{{ phase.life_losed }}</span><icon file="heart" :size="24" />
					</div>
				</div>
			</transition>
			<div v-show="position === 1" class="first-time">
				<p>Faites un mot avec les lettres de l'ennemi pour vous défendre.<br>Elles apparaissent en jaune sur votre clavier.</p>
				<p>Attention : Les lettres restantes vous infligeront des dégâts.</p>
			</div>
		</div>



		<div v-if="phase.type == 'loot'" class="loot">
			<div class="intro">Choisissez votre récompense :</div>
			<div class="choices">
				<div v-for="loot in phase.loots" class="choice" :class="{ active: loot.active }" @click="gain_loot(loot)" @mouseenter="set_active(loot)">
					<div class="name">{{ loot.name }}</div>
					<div v-if="loot.type == 'letter'" class="touch"><key :touch="{ letter: loot.value, active: true }" /></div>
					<div v-if="loot.type == 'heal'" class="hearts">
						<span v-for="i in loot.value" class="heart"><icon file="heart" /></span>
					</div>
					<div v-if="loot.type == 'life-up'" class="hearts life-up">
						<span v-for="i in loot.value" class="heart"><icon file="heart" /></span>
					</div>
				</div>
			</div>
		</div>



		<div v-if="phase.type == 'tuto'" class="tuto">
			<div class="text-tuto">
				<p>
					Cette vieille machine à écrire est cassée.
					<br>
					Il lui manque des touches et elle fait apparaître des mots démoniaques !
				</p>
				<p>Utiliser votre clavier pour vous battre face à eux.</p>
				<div class="tuto-hint">
					<p>Récupérer toutes les touches pour réparer la machine à écrire.</p>
				</div>
			</div>
			<div class="intro">
				<p>Taper un mot pour commencer la partie</p>
				<p class="small">Ou [espace] pour passer à la suite</p>
			</div>
			
		</div>



		<div v-if="phase.type == 'lose'" class="lose">
			<div class="intro"><p>Fin de partie</p></div>
			<div class="lose-icon"><icon file="daemon-skull" :size="80" /></div>

			<div class="score">
				<div class="score-value">
					{{ game.player.letters_destroyed }}
					<span class="p1">lettres</span>
					<span class="p2">détruites</span>
				</div>
			</div>

			<div class="buttons">
				<div class="button" @click="new_game()"><icon file="rotate-cw" :size="24" />Nouvelle partie</div>
			</div>

		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Phase',
	data () {
		return {

		}
	},
	props: [ 'phase', 'position' ],
	computed: Object.assign(mapGetters([ 'game', 'active_phase' ]), {

	}),
	methods: {
		gain_loot: function(loot) {
			this.$store.dispatch('gain_loot', { loot: loot })
		},
		set_active: function(loot) {
			this.$store.dispatch('set_loot_active', { loot: loot })
		},
		new_game: function() {
			var that = this
			this.$store.dispatch('end_game')
			setTimeout(function() {
				that.$store.dispatch('init')
				setTimeout(function() {
					that.$store.dispatch('start_game')
				}, 500)
			}, 500)
		}
	}
}
</script>

<style lang="stylus">
@import '../assets/css/app'


.phase
	padding 32px 0
	border-bottom 1px dashed #ddd
	opacity 0.5
	&:last-child
		border-bottom none
		padding-bottom 0
	&.active
		opacity 1
	.intro
		font-size 20px
		line-height 22px
		text-align center
		margin 0 0 16px 0
		p
			margin 0
			&.small
				font-size 14px
				color #bbb
				text-align center
	.first-time
		font-size 16px
		line-height 18px
		margin 24px 0 0 0
		color #999
		p
			margin 0 0 8px 0
			&:last-child
				margin 0
	.lose-life
		padding 16px 0 0 0
		height 40px
		text-align center
		color red
		font-size 24px
		line-height 20px
		display flex
		align-items center
		justify-content center
		transition 0.25s easeOutQuart
		&.life-losed-enter
			opacity 0
			transform scale(3)
		.life
			display inline-block
			.icon
				float right
				margin 0 0 0 6px
	.enemy
		color red
		text-align center
		.word
			display block
			display flex
			align-items center
			justify-content center
			.letter
				display inline-block
				height 56px
				width 40px
				margin 0 2px
				background lighten(red, 90%)
				line-height @height
				text-align center
				&:nth-child(1)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(4) rotate(-20deg)
				&:nth-child(2)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(3) rotate(15deg)
				&:nth-child(3)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(3) rotate(0deg)
				&:nth-child(4)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(2.5) rotate(-10deg)
				&:nth-child(5)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(3.5) rotate(25deg)
				&:nth-child(6)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(2.5) rotate(25deg)
				&:nth-child(7)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(4) rotate(-20deg)
				&:nth-child(8)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(3) rotate(15deg)
				&:nth-child(9)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(3) rotate(0deg)
				&:nth-child(10)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(2.5) rotate(-10deg)
				&:nth-child(11)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(3.5) rotate(25deg)
				&:nth-child(12)
					.letter-text.enemy-leave-to
						transform translate3D(0, -100%, 0) scale(2.5) rotate(25deg)
				.letter-text
					transition 0.5s easeOutQuart
					&.enemy-leave-to
						opacity 0
						transform translate3D(0, -100%, 0) scale(2) rotate(0deg)
	.choices
		display flex
		align-items center
		justify-content center
		.choice
			background lighten(blue, 95%)
			color darken(blue, 40%)
			width 140px
			height 160px
			padding 8px
			margin 0 8px
			font-size 18px
			line-height 18px
			text-align center
			display flex
			align-items center
			flex-direction column
			justify-content center
			// opacity 0.5
			color #666
			&.active
				box-shadow 0 0 0 2px lighten(blue, 50%)
				background lighten(blue, 85%)
				opacity 1
				color blue
			.name
				display block
				margin 0 0 16px 0
			.touch
				width 64px
				height 64px
			.hearts
				padding 0 16px
				color red
				&.life-up
					color #ccc
				.heart
					display inline-block
					.icon
						display block
	.tuto
		.text-tuto
			font-size 16px
			line-height 18px
			margin 0 0 24px 0			
			p
				margin 0 0 8px 0
				&:last-child
					margin 0
			.tuto-hint
				margin 16px 0 0 0
				border-left 4px solid blue
				padding 0 0 0 16px
				color blue
				p
					margin 0
	.lose
		font-size 20px
		line-height 22px
		.lose-icon
			display block
			text-align center
			margin 0 0 24px 0
		.score
			margin 0 0 24px 0
			text-align center
			.score-value
				display inline-block
				font-size 48px
				line-height @font-size
				white-space nowrap
				.p1, .p2
					position absolute
					left calc(100% + 8px)
					font-size 14px
					line-height 16px
					text-align left
					color #999
				.p1
					top 8px
				.p2
					bottom 8px
		.buttons
			display flex
			align-items center
			justify-content center
			.button
				display inline-block
				height 48px
				padding 12px 24px
				background blue
				border-radius 8px
				box-shadow inset 0 -4px 0 0 alpha(#000, 15%)
				line-height 20px
				color #fff
				font-size 18px
				&:active
					transform translate3D(0, 3px, 0)
					box-shadow inset 0 -1px 0 0 alpha(#000, 15%)
				.icon
					float left
					line-height 24px
					margin 0 12px 0 0

</style>



// WEBPACK FOOTER //
// src/components/Phase.vue